import { useFeatureFlag } from '@newfront-insurance/admin-ui';
import type { JSX } from 'react';

import { HeadTitle } from '@/client/components/head-title';
import Page404 from '@/pages/404';

export default function ChatPage(): JSX.Element {
  const isChatEnabled = useFeatureFlag('nova-chat-overlay', false);
  // Chat is rendered by the chat overlay provider in the root layout
  return isChatEnabled ? <HeadTitle title="Nova - Chat" /> : <Page404 />;
}
